export default __webpack_public_path__ + "static/media/65-min.f5b88d91.png";